// extracted by mini-css-extract-plugin
module.exports = {"charts":"CasesCharts_charts__InAHJ"};